export default {
  name: 'Home',
  path: '/',
  meta: {
    title: 'GeminiXiang Studio'
  }
};